import { t } from "@lingui/core/macro";
import { clsx } from "@regrello/core-utils";
import React from "react";

/**
 * A "Beta" label that with a snazzy text gradient, intended to communicate when a neighboring
 * element is still experimental.
 */
export const RegrelloBetaLabel = React.memo<{ children?: never }>(function RegrelloBetaLabelFn() {
  return (
    <span
      className={clsx(
        "text-sm",
        "font-semibold",
        "bg-gradient-to-br",
        // (clewis): Custom colors just for some pizzazz in this one spot (looks good in dark theme, too):
        "from-[#DB2777]", // Same as Tailwind CSS pink-600
        "via-secondary-textMuted",
        "to-primary-textMuted",
        "text-transparent",
        "bg-clip-text",
        "uppercase",
      )}
    >
      {t`Beta`}
    </span>
  );
});
